import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import StepContainer from '../StepContainer';
import RadioBtnCard from '../RadioBtnCard';
import FixedFooter from '../Footer/FixedFooter';

import { authUserOperations } from '@evdy/web-redux/dist/lib/authUser';

import coupleContourImg from '../../public/images/couple-contour.svg';

import styles from './SelectPackage.module.scss';

const { savePackageToUser, resetSelectedPackage, saveLastScreen } = authUserOperations;

const {
  'select-package': selectPackageClass,
  'radio-btn-card': radioBtnCardClass,
  'package-card': packageCardClass,
  'package-image': packageImageClass,
  'card-body': cardBodyClass,
  'card-body-title': cardBodyTitleClass,
  'card-body-description': cardBodyDescriptionClass,
  'card-body-price': cardBodyPriceClass,
  'footer-card': footerCardClass,
  'footer-card-image': footerCardImageClass,
  'footer-card-body': footerCardBodyClass,
  'footer-card-body-title': footerCardBodyTitleClass,
  'footer-card-body-subtitle': footerCardBodySubtitleClass
} = styles;

const SelectPackage = ({ location }) => {
  const { authUser, preneedPackages = [] } = useSelector(({ authUser, webPurchase }) => ({
    authUser: authUser,
    preneedPackages: webPurchase.preneedPackages.data?.packages
  }));

  const { isFetching, packageSelected, data: userData } = authUser || {};

  const dispatch = useDispatch();

  // move to next step after saving package
  useEffect(() => {
    if (packageSelected) {
      dispatch(resetSelectedPackage());
      dispatch(saveLastScreen({ screen: 'chooseProvider' }));
    }
  }, [packageSelected]);

  const initialValues = {
    selectedPackage: userData?.preneed?.packageName || ''
  };

  const validationSchema = Yup.object().shape({
    selectedPackage: Yup.string().required()
  });

  const onSubmit = values => {
    const packageId = preneedPackages.find(pkg => pkg.name === values.selectedPackage)?.packageId;
    dispatch(savePackageToUser(packageId));
  };

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      validateOnMount
    >
      {({ values, isValid, handleSubmit }) => (
        <>
          <StepContainer
            evelynArray={[
              'Whichever path you choose, you can’t go wrong with our cremation and service packages because we make sure every detail is covered.',
              { style: 'header', content: 'Which of these experiences best fits your wishes?' }
            ]}
            showLoader={isFetching}
            {...{ location }}
          >
            <div className={selectPackageClass}>
              <Form>
                {preneedPackages?.map(p => (
                  <RadioBtnCard
                    key={p.name}
                    fieldName="selectedPackage"
                    name={p.name}
                    value={p.name}
                    isChecked={values?.selectedPackage === p.name}
                    customClass={radioBtnCardClass}
                  >
                    <div className={packageCardClass}>
                      <div className={packageImageClass}>
                        <img src={p.experienceImageUrl} alt="" />
                      </div>
                      <div className={cardBodyClass}>
                        <div className={cardBodyTitleClass}>{p.experienceTitle}</div>
                        <div className={cardBodyDescriptionClass}>{p.experienceSubtitle}</div>
                        <div className={cardBodyPriceClass}>{p.experiencePrice}</div>
                      </div>
                    </div>
                  </RadioBtnCard>
                ))}
              </Form>
              <div className={footerCardClass}>
                <div className={footerCardImageClass}>
                  <img src={coupleContourImg} alt="" />
                </div>
                <div className={footerCardBodyClass}>
                  <div className={footerCardBodyTitleClass}>
                    We proudly never sell “just a cremation”
                  </div>
                  <div className={footerCardBodySubtitleClass}>
                    Your family will need so much more than that. Every package we offer includes
                    quality services and professional guidance to help loved ones navigate through a
                    very difficult time, saving them from unexpected and stressful decisions about
                    what to do.
                  </div>
                </div>
              </div>
            </div>
          </StepContainer>
          <FixedFooter isValid={isValid} nextCopy="Next" nextAction={handleSubmit} />
        </>
      )}
    </Formik>
  );
};

export default SelectPackage;
